import * as React from 'react'

import Header from 'modules/core/components/Card/CardHeader'
import type { Back, Background } from 'modules/core/components/Card/types'

import RightAction from './RightAction'

interface Props {
  inverted?: boolean
  back?: Back | (() => void)
  left?: React.ReactNode
  middle?: React.ReactNode
  right?: React.ReactNode
  background?: Background
  fancy?: boolean
}

const CardHeader = (props: React.PropsWithChildren<Props>) => {
  return <Header {...props} />
}

CardHeader.RightAction = RightAction

export default CardHeader
